import { render, staticRenderFns } from "./FacialDeviceTable.vue?vue&type=template&id=fd3f36f2&scoped=true&"
import script from "./FacialDeviceTable.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3f36f2",
  null
  
)

export default component.exports